import { AppSettingsRepo, SettingsKeys } from '../../../domain/settings/IAppSettingsRepo';

const getStunOnlySetting = async (): Promise<boolean> => {
	const setting =  await AppSettingsRepo.get(SettingsKeys.stunOnly)
	return !!setting;
}

export default getStunOnlySetting;